function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Represents a fixed list of string values. Construct a new enum by invoking
// the constructor with an array of strings:
//
//   Colors = new Enum('RED', 'GREEN', 'BLUE')
//   assert Colors.RED is 'RED'
//   assert Colors.hasValue('RED')
//
//   assert Colors.deserialize('CHARTREUSE') is '_UNKNOWN_VALUE_CHARTREUSE' // CHARTREUSE isn't a member of this enum so it returns the special unknown value enum value
//   assert not Colors.hasValue('_UNKNOWN_VALUE')
//
// In browsers that support Object.freeze(), the values of the resulting enum
// cannot be modified and changes will be silently ignored:
//
//   Colors.GREEN = 'YELLOW'
//   Colors.GREEN // 'GREEN'
//

const UNKNOWN_VALUE_PREFIX = '_UNKNOWN_VALUE_';
export default class Enum {
  constructor(...values) {
    _defineProperty(this, "values", void 0);
    let realValues;
    if (values.length === 1 && Array.isArray(values[0])) {
      realValues = values[0];
    } else {
      // TypeScript can't figure out that we ruled out [readonly T[]]
      realValues = values;
    }
    const newValues = [];
    for (const [i, value] of realValues.entries()) {
      newValues[i] = value;
      this[value] = value;
    }
    this.values = newValues;
    if (Object.freeze) {
      Object.freeze(this.values);
      Object.freeze(this);
    }
  }
  hasValue(value) {
    return this.hasOwnProperty(value); // eslint-disable-line no-prototype-builtins
  }

  // Provides support for Ember.attr() serialization with Ember Model.
  serialize(value) {
    if (this.hasValue(value)) {
      return value;
    } else if (value !== null && value !== undefined) {
      return value.slice(UNKNOWN_VALUE_PREFIX.length);
    } else {
      return value;
    }
  }

  // Provides support for Ember.attr() deserialization with Ember Model.
  deserialize(value) {
    if (this.hasValue(value)) {
      return value;
    } else if (value !== null && value !== undefined) {
      return `${UNKNOWN_VALUE_PREFIX}${value}`;
    } else {
      return value;
    }
  }
  indexOf(value) {
    return this.values.indexOf(value);
  }

  // Prefer using this over new for anything using TypeScript, since it
  // otherwise it won't know about the dynamic fields
  // If you're dealing with something new, it's probably better to use native enums instead.
  static create(...values) {
    return new Enum(...values);
  }
}